<template>
    <div class="main main-padding">
        <!-- 移动授课总用户数、 移动授课助手使用次数Top5用户、移动授课助手月活跃用户数 -->
        <Row :gutter="10" style="margin-top: 20px;">
            <Col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
                <Card style="height:413px;">
                    <div style="text-align:center; font-weight: bold;">
                        <img src="../../../assets/images/move.png" style="margin-top: 14%;">
                        <div style="margin-top: -2%;font-size:37px">移动授课总用户数:{{baseData.moveTeaUser}}</div>
                    </div>
                </Card>
            </Col>
            <Col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
                <histogram-charts
                    :chartsTitle="'移动授课助手使用次数Top5用户'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'mobile_use_top'"
                    :height="'360px'"
                    :histogramTooltip="'useSecond'"
                    ref="mobileUseTop"
                ></histogram-charts>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="10" :xl="10">
                <line-charts
                    :chartsTitle="'移动授课助手月活跃用户数'"
                    :chartsId="'mobile_month_user'"
                    :lineCompany="'人'"
                    ref="mobileMonthUser"
                ></line-charts>
            </Col>
        </Row>
        <!-- 移动授课助手日活跃用户数、 移动授课助手周活跃用户数 -->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="24" :lg="12" :xl="24">
                <line-charts
                    :chartsTitle="'移动授课助手日活跃用户数'"
                    :chartsId="'mobile_day_user'"
                    :lineCompany="'人'"
                    ref="mobileDayUser"
                ></line-charts>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="12" :xl="24">
                <line-charts
                    :chartsTitle="'移动授课助手周活跃用户数'"
                    :chartsId="'mobile_week_user'"
                    :lineCompany="'人'"
                    ref="mobileWeekUser"
                ></line-charts>
            </Col>
        </Row>
        <!--移动授课助手各校用户使用次数 -->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <histogram-charts
                    :chartsTitle="'移动授课助手各校用户使用次数'"
                    :isShowMore=false
                    :isClickCharts=false
                    :isSchool=true
                    :chartsId="'mobile_school_time'"
                    :height="'360px'"
                    :histogramTooltip="'useSecond'"
                    ref="mobileSchoolTime"
                ></histogram-charts>
            </Col>
        </Row>
        <!--  移动授课助手主要使用场景、移动授课助手学段使用情况分布 -->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <histogram-charts
                    :chartsTitle="'移动授课助手主要使用场景'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'mobile_main_scene'"
                    :height="'360px'"
                    :histogramTooltip="'useSecond'"
                    ref="mobileMainScene"
                ></histogram-charts>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <pie-charts
                :chartsTitle="'移动授课助手学段使用情况分布'"
                :isShowMore=false
                :isClickCharts=false
                :chartsId="'mobile_stage_distri'"
                :pieChartsName="'学段分布'"
                ref="mobileStageDistri"
            ></pie-charts>
            </Col>
        </Row>
        <!--  移动授课助手使用用户学科分布 -->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <histogram-charts
                    :chartsTitle="'移动授课助手使用用户学科分布'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'mobile_subject_distri'"
                    :height="'360px'"
                    :histogramTooltip="'people'"
                    ref="mobileSubjectDistri"
                ></histogram-charts>
            </Col>
        </Row>
    </div>
</template>
<script>
    import HistogramCharts from "../../../components/charts/HistogramCharts.vue";//柱状图
    import PieCharts from "../../../components/charts/PieCharts.vue";//饼状图
    import LineCharts from "../../../components/charts/LineCharts.vue";//折线图
    import {findUseNum, findUserTop,findUserWeekly, findUseSchool, findUseScene, findSubjectMap,findSubjectAnaly} from "../../../service/api.js";

    export default {
        name: "move-tea-main",
        data () {
            return {
                baseData: {
                    moveTeaUser: 0  //移动授课总用户数
                }
            };
        },
        components: {
            HistogramCharts,//柱状图组件
            PieCharts,//饼图组件
            LineCharts//折线图
        },
        methods: {
            /**
             * 获取智能PC总用户数
             */
            async getUseNum () {
                let _this = this;
                await findUseNum()
                    .then(function (data) {
                        _this.baseData.moveTeaUser = data;
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取移动授课助手使用次数Top5用户
             */
            async getUserTop () {
                let _this = this;
                await findUserTop()
                    .then(function (data) {
                        let topUserList = data;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        let displayName = "";
                        //处理数据以渲染图表
                        for (let i = 0; i < topUserList.length; i++) {
                            displayName = topUserList[i].fullName;
                            xDataArr.push(
                                displayName.length > 5
                                    ? displayName.substring(0, 5) + "..."
                                    : displayName
                            );
                            seriesDataArr.push(topUserList[i].count);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.mobileUseTop.initDataSource(topUserList, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取移动授课助手日周月活跃用户
             */
            async getUserWeekly() {
                let _this = this;
                await findUserWeekly()
                    .then(function(data) {
                        let useList = data;
                        let dayDateArr = [];let dayNumArr = [];
                        let weekDateArr=[];let weekNumArr=[];
                        let monthDateArr=[];let monthNumArr=[];
                        //日活
                        for (let i = 0; i < useList.day.length; i++) {
                            dayDateArr.push(useList.day[i].date);
                            dayNumArr.push(useList.day[i].number);
                        }
                        //周活
                        for (let i = 0; i < useList.week.length; i++) {
                            let strWeekStr = useList.week[i].dates.substring(5, 11);
                            let endWeekStr = useList.week[i].dates.substring(16);
                            let weekStr = strWeekStr + endWeekStr;
                            weekDateArr.push(weekStr);
                            weekNumArr.push(useList.week[i].number);
                        }
                        //月活
                        for (let i = 0; i < useList.month.length; i++) {
                            monthDateArr.push(useList.month[i].month);
                            monthNumArr.push(useList.month[i].userCount);
                        }
                        _this.$nextTick(() => {
                            //渲染日活图表
                            _this.$refs.mobileDayUser.initDataSource(useList.day, dayDateArr, dayNumArr);
                            //渲染周活图表
                            _this.$refs.mobileWeekUser.initDataSource(useList.week, weekDateArr, weekNumArr);
                            //渲染月活图表
                            _this.$refs.mobileMonthUser.initDataSource(useList.month, monthDateArr, monthNumArr);
                        })
                    })
                    .catch(function(error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取移动授课助手各校用户使用次数
             */
            async getUseSchool () {
                let _this = this;
                await findUseSchool()
                    .then(function (data) {
                        let schoolList = data;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        //处理数据以渲染图表
                        for (let i = 0; i < schoolList.length; i++) {
                            xDataArr.push(schoolList[i].schoolName);
                            seriesDataArr.push(schoolList[i].count);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.mobileSchoolTime.initDataSource(schoolList, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取授课助手主要使用场景
             */
            async getUseScene () {
                let _this = this;
                await findUseScene()
                    .then(function (data) {
                        let sceneList = data;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        let displayName = "";
                        //处理数据以渲染图表
                        for (let i = 0; i < sceneList.length; i++) {
                            displayName = sceneList[i].funcName;
                            xDataArr.push(
                                displayName.length > 5
                                    ? displayName.substring(0, 5) + "..."
                                    : displayName
                            );
                            seriesDataArr.push(sceneList[i].count);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.mobileMainScene.initDataSource(sceneList, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取移动授课助手学段使用情况分布
             */
            async getSubjectMap () {
                let _this = this;
                await findSubjectMap()
                    .then(function (data) {
                        let stageList = data;
                        let nameArr = [];
                        let dataArr = [];
                        for (let i = 0; i < stageList.length; i++) {
                            let obj = {};
                            //处理数据用于渲染图表
                            obj.value = stageList[i].usercount;
                            obj.name = stageList[i].class;
                            dataArr.push(obj);
                            nameArr.push(stageList[i].class);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.mobileStageDistri.initDataSource(stageList, nameArr, dataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取移动授课助手用户学科分布
             */
            async getSubjectAnaly () {
                let _this = this;
                await findSubjectAnaly()
                    .then(function (data) {
                        let subList = data;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        let displayName = "";
                        //处理数据以渲染图表
                        for (let i = 0; i < subList.length; i++) {
                            displayName = subList[i].subName;
                            xDataArr.push(
                                displayName.length > 5
                                    ? displayName.substring(0, 5) + "..."
                                    : displayName
                            );
                            seriesDataArr.push(subList[i].userCount);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.mobileSubjectDistri.initDataSource(subList, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            }
        },
        mounted () {
            this.$store.commit("SET_TOPHEADERNAME", "移动授课助手产品使用统计");
            // 获取智能PC总用户数
            this.getUseNum();
            //获取移动授课助手使用次数Top5用户
            this.getUserTop();
            //获取移动授课助手日周月活跃用户
            this.getUserWeekly();
            //获取移动授课助手各校用户使用次数
            this.getUseSchool();
            //获取授课助手主要使用场景
            this.getUseScene();
            //获取移动授课助手学段使用情况分布
            this.getSubjectMap();
            //获取移动授课助手用户学科分布
            this.getSubjectAnaly();
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../../style/home";
</style>
